import TextInput from "components/TextInput";
import styled from "styled-components";

export const DurationPickerWrapper = styled.div`
    display: flex;
    gap: 1rem;
    align-items: end;
`;

export const DurationInput = styled(TextInput)`
    margin-right: 0.5rem;
    width: 100%;
    min-width: 3rem;
    padding-right: 0;
`;
